<div class="breadcrumb">
	<p class="{{!!item.abstract ? 'abstract': '' }}" (click)="route(item)" *ngFor="let item of breadcrumbs">
		&nbsp;/&nbsp;<span>{{item.title}}</span></p>
</div>